import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, toHandlers as _toHandlers, mergeProps as _mergeProps, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-108de472"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "textHidden" }
const _hoisted_3 = ["data-maska", "disabled", "max", "min", "placeholder", "required", "type"]
const _hoisted_4 = {
  key: 4,
  class: "inputBox__arrows"
}
const _hoisted_5 = {
  style: /*#__PURE__*/_normalizeStyle([{ height: '10px' }])
}
const _hoisted_6 = {
  style: /*#__PURE__*/_normalizeStyle([{ height: '10px' }])
}
const _hoisted_7 = {
  key: 5,
  class: "inputBox__error"
}
const _hoisted_8 = {
  key: 6,
  class: "inputBox__append-icon"
}
const _hoisted_9 = { key: 7 }
const _hoisted_10 = { class: "inputBox__append-icon" }
const _hoisted_11 = {
  key: 0,
  class: "inputBox__append-icon"
}
const _hoisted_12 = {
  key: 1,
  class: "inputBox__append-icon"
}

import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { StylesType } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseInput',
  props: /*#__PURE__*/_mergeModels({
    placeholder: {},
    modelValue: { default: undefined },
    type: {},
    min: { default: undefined },
    max: { default: undefined },
    hideArrows: { type: Boolean },
    disabled: { type: Boolean },
    label: {},
    step: { default: 1 },
    labelInValue: { type: Boolean, default: false },
    height: { default: '36' },
    filled: { type: Boolean, default: false },
    styles: {},
    styleType: { default: undefined },
    withoutFocus: { type: Boolean, default: false },
    required: { type: Boolean },
    invalid: { type: Boolean },
    dataMaska: {},
    error: {},
    prefix: {},
    autoFocus: { type: Boolean, default: false },
    appendIcon: {},
    isPercent: { type: Boolean },
    loading: { type: Boolean },
    withBg: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['update:modelValue', 'focus', 'blur', 'input'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
// eslint-disable-next-line no-undef
const inputValue = _useModel<string | number | undefined | null>(__props, "modelValue");
const tooltipActive = ref(false);
const inputLabel = ref<HTMLElement | undefined>();

const inputType = computed((): string | undefined => {
  if (props.type === 'number' || showPassword.value) {
    return 'text';
  }

  if (props.type === 'date' && !isFocusInput.value) {
    return 'text';
  }

  return props.type;
});

const showPassword = ref(false);

const isFocusInput = ref(false);
const changeFocus = (bool: boolean) => {
  if (props.withoutFocus && bool) {
    element.value?.blur();

    return;
  }
  isFocusInput.value = bool;
  if (!bool) {
    if (props.type === 'number' && inputValue.value) {
      let val = +String(inputValue.value).replace(/\s/g, '');

      if (props.min !== undefined && val < props.min) {
        inputValue.value = readableNumber(String(props.min));
      } else if (props.max !== undefined && val > props.max) {
        inputValue.value = readableNumber(String(props.max));
      }
      errorMessage.value = '';
      isError.value = false;
    }
    // emit('update:modelValue', inputValue.value);
  }
};
const element = ref<HTMLInputElement | undefined>();
const focusInput = () => {
  setTimeout(() => {
    element.value?.focus();
  }, 10);
};
const isStepUpAllowed = computed((): boolean => {
  return (
    !props.disabled &&
    (props.max === undefined || parseInt(String(inputValue.value), 10) < props.max)
  );
});
const stepUp = () => {
  if (inputValue.value === undefined || inputValue.value === null) return;
  if (!isStepUpAllowed.value) return;

  const newValue = +inputValue.value + props.step;

  if (newValue != null) {
    inputValue.value = newValue;

    // return emit('update:modelValue', newValue);
  }
};

const isStepDownAllowed = computed((): boolean => {
  return (
    !props.disabled &&
    (props.min === undefined || parseInt(String(inputValue.value), 10) > props.min)
  );
});
const stepDown = () => {
  if (inputValue.value === undefined || inputValue.value === null) return;
  if (!isStepDownAllowed.value) return;

  const newValue = +inputValue.value - props.step;

  if (newValue) {
    inputValue.value = newValue;
  } else {
    inputValue.value = props.min || 0;
  }
};

const listeners = computed(() => ({
  input: handleInput,
  focus: (e: PointerEvent) => emit('focus', e),
  blur: (e: PointerEvent) => emit('blur', e),
}));
const emitValue = (event: InputEvent) => {
  let value = (event.target as HTMLInputElement).value;

  emit('update:modelValue', value);
};

const cssProps = computed(() => {
  return {
    '--border': props.styles?.border,
    '--background-color': props.styles?.backgroundColor,
    '--border-radius': props.styles?.borderRadius,
  };
});
const readableNumber = (value: string) => {
  return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

const errorMessage = ref('');
const isError = ref(false);
const handleInput = (e: InputEvent) => {
  if (props.type === 'number') {
    const target = e.target as HTMLInputElement;
    let val = target.value.replace(/\s/g, '');

    //если были введены не числа
    const pattern = /^\d+$/;

    if (!pattern.test(val)) {
      isError.value = true;
      errorMessage.value = 'Только цифры';
      let start = target.selectionStart! - 1;
      const numberValue = readableNumber(val.replace(/[^0-9]/g, ''));

      nextTick(() => {
        target.selectionStart = target.selectionEnd = start;
      });
      inputValue.value = numberValue;

      return;
    }

    // Если был удален пробел
    const readablePattern = /\B(?=(\d{3})+(?!\d))/g;

    if (
      (e.inputType === 'deleteContentBackward' ||
        e.inputType === 'deleteContentForward') &&
      readablePattern.test(target.value)
    ) {
      let start = target.selectionStart!;

      if (e.inputType === 'deleteContentBackward') {
        start = start - 1;
      }
      const arr = target.value.split('');

      arr.splice(start, 1);
      const newVal = arr.join('').replace(/\s/g, '');

      inputValue.value = readableNumber(newVal);
      nextTick(() => {
        target.selectionStart = target.selectionEnd = start + 1;
      });

      return;
    }

    //добавление пробелов и перенос курсора
    let start = target.selectionStart ?? 0;
    let number = target.value.split(' ').length - 1;

    if (props.min !== undefined && +val < props.min) {
      errorMessage.value = `Минимальное значение: ${readableNumber(String(props.min))}`;
      isError.value = true;
    } else if (props.max !== undefined && +val > props.max) {
      errorMessage.value = `Максимальное значение: ${readableNumber(String(props.max))}`;
      isError.value = true;
    } else {
      errorMessage.value = '';
      isError.value = false;
    }
    inputValue.value = readableNumber(val);
    number = String(readableNumber(val)).split(' ').length - 1 - number;
    start = start + number < 0 ? 0 : start + number;

    nextTick(() => {
      target.selectionStart = target.selectionEnd = start;
    });
  } else {
    emitValue(e);
  }
};

onMounted(() => {
  if (props.type === 'number') {
    if (inputValue.value !== undefined && inputValue.value !== null) {
      if (props.min !== undefined) {
        if (+inputValue.value >= props.min) {
          inputValue.value = readableNumber(String(inputValue.value));
        }
      } else {
        inputValue.value = readableNumber(String(inputValue.value));
      }
    } else {
      inputValue.value = undefined;
    }
  }

  if (props.autoFocus) {
    focusInput();
  }

  if (inputLabel.value) {
    if (inputLabel.value.clientWidth < inputLabel.value.scrollWidth) {
      tooltipActive.value = true;
    }
  }
});

watch(inputValue, (newValue, oldValue) => {
  //Приводим число к нужному типу
  if (props.type === 'number') {
    if (newValue !== undefined && newValue !== null) {
      const preparedNewValue = `${newValue}`.replace(/[^0-9]/g, '');
      const preparedOldValue = `${oldValue}`.replace(/[^0-9]/g, '');

      const preparedNumber = readableNumber(String(newValue));

      if (preparedNewValue !== preparedOldValue || newValue !== preparedNumber) {
        inputValue.value = preparedNumber;
      }
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_skeleton_loader = _resolveComponent("base-skeleton-loader")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_tooltip = _resolveComponent("base-tooltip")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_base_skeleton_loader, { type: "input" })
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass([_ctx.styleType, "inputBox"]),
        style: _normalizeStyle([
      cssProps.value,
      {
        height: _ctx.height + 'px',
      },
    ])
      }, [
        _createVNode(_component_base_tooltip, {
          active: tooltipActive.value,
          "show-in-mobile": false,
          text: _ctx.label
        }, {
          default: _withCtx(() => [
            (_ctx.labelInValue)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass([{ isFocusInput: isFocusInput.value }, "inputBox__labelInValue"]),
                  onClick: focusInput
                }, _toDisplayString(_ctx.label), 3))
              : _createCommentVNode("", true),
            (_ctx.prefix)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass([{ isFocusInput: isFocusInput.value, invalid: _ctx.invalid }, "inputBox__labelInValue"])
                }, _toDisplayString(inputValue.value || isFocusInput.value ? _ctx.prefix : ''), 3))
              : _createCommentVNode("", true),
            (
          _ctx.withBg &&
          !isFocusInput.value &&
          inputValue.value !== undefined &&
          inputValue.value !== null &&
          inputValue.value !== ''
        )
              ? (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: "inputBox__value",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (changeFocus(true)))
                }, [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.prefix) + _toDisplayString(inputValue.value), 1)
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", _mergeProps({
              ref_key: "element",
              ref: element,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputValue).value = $event)),
              class: [
          { labelInValue: _ctx.labelInValue || _ctx.prefix },
          { filledInput: _ctx.filled },
          { error: isError.value || errorMessage.value },
          { invalid: _ctx.invalid },
          { valid: inputValue.value },
          { paddingRight: _ctx.type === 'password' },
        ],
              "data-maska": _ctx.dataMaska,
              disabled: _ctx.disabled,
              max: _ctx.max,
              min: _ctx.min,
              placeholder: _ctx.placeholder,
              required: _ctx.required,
              type: inputType.value,
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (changeFocus(false))),
              onFocus: _cache[3] || (_cache[3] = ($event: any) => (changeFocus(true)))
            }, _toHandlers(listeners.value, true)), null, 16, _hoisted_3), [
              [_vModelDynamic, inputValue.value]
            ]),
            (!_ctx.labelInValue)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 3,
                  ref_key: "inputLabel",
                  ref: inputLabel,
                  class: _normalizeClass([{ topMore: _ctx.withBg }, "inputBox__label"])
                }, _toDisplayString(_ctx.label), 3))
              : _createCommentVNode("", true),
            (_ctx.type === 'number' && !_ctx.hideArrows)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_base_icon, {
                      class: _normalizeClass([{ disabled: !isStepUpAllowed.value }, "step-up"]),
                      disabled: !isStepUpAllowed.value,
                      clickable: "",
                      height: "10",
                      name: "arrow_drop_up",
                      tabindex: "-1",
                      width: "10",
                      onClick: stepUp
                    }, null, 8, ["class", "disabled"])
                  ]),
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_base_icon, {
                      class: _normalizeClass([{ disabled: !isStepDownAllowed.value }, "step-down"]),
                      disabled: !isStepDownAllowed.value,
                      clickable: "",
                      height: "10",
                      name: "arrow_drop_down",
                      tabindex: "-1",
                      width: "10",
                      onClick: stepDown
                    }, null, 8, ["class", "disabled"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (isError.value || errorMessage.value?.length || _ctx.error?.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(errorMessage.value || _ctx.error), 1))
              : _createCommentVNode("", true),
            (_ctx.type === 'password')
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createVNode(_component_base_icon, {
                    height: _ctx.height,
                    name: showPassword.value ? 'visibility' : 'visibility_off',
                    clickable: "",
                    color: "#888298",
                    width: "21",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (showPassword.value = !showPassword.value))
                  }, null, 8, ["height", "name"])
                ]))
              : _createCommentVNode("", true),
            (
          !isFocusInput.value &&
          inputValue.value !== undefined &&
          inputValue.value !== null &&
          inputValue.value !== ''
        )
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _renderSlot(_ctx.$slots, "appendIcon")
                  ]),
                  (!_ctx.$slots.appendIcon && _ctx.appendIcon)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createVNode(_component_base_icon, {
                          height: _ctx.height,
                          name: _ctx.appendIcon,
                          color: "#94857d",
                          width: "21"
                        }, null, 8, ["height", "name"])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.$slots.appendIcon && _ctx.isPercent)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                        _createVNode(_component_base_icon, {
                          height: _ctx.height,
                          color: "#94857d",
                          name: "percent",
                          width: "21"
                        }, null, 8, ["height"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["active", "text"])
      ], 6))
}
}

})